import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Input, Pagination, Form, Select } from 'antd';
import { app } from '../../config';
import NewSideBar from '../../components/Sidebar/NewSideBar';
import { EditTwoTone, CheckCircleFilled } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import userEvent from '@testing-library/user-event';
import NoRecordFound from '../../components/common/NoRecordFound';
import useFetchOrganizations from '../../hooks/fetchOrganizations';

const Cause = () => {
  const { Search } = Input;
  const [form] = Form.useForm();
  const { t } = useTranslation(['common']);
  const [current, setCurrent] = useState(1);
  const [renderList, setRenderList] = useState([]);
  const [commonData, setCommonData] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [pageObj, setPageObj] = useState({});
  const [orgdata, setOrgData] = useState();
  const [cause, setCause] = useState([]);
  const [clearSearch, setClearSearch] = useState(false);
  let navigate = useNavigate();
  const token = getTokenfromUserObj();
  const user = JSON.parse(localStorage.getItem('user'));
  const orgResp = useFetchOrganizations();
  console.log(orgResp);
  let orgObj = orgResp.response ? orgResp.response.data : [];
  // causes.length>1?setRenderList(causes.slice(0,6)):" ";
  const fetchCauses = async () => {
    console.log('Fetch Causes');
    const limit = 6;
    const offset = 0;
    let fetchCauseAPI;
    if (user.userType === 'A') fetchCauseAPI = `${app.URL}/cause/viewdetails`;
    else if (user.userType === 'O') fetchCauseAPI = `${app.URL}/cause/viewbyorg?orgId=${user.organizationId}`;
    const causeResp = await axios.get(fetchCauseAPI, { headers: { auth: token } });
    causeResp.data ? setCause(causeResp.data.data) : [];
    causeResp.data ? setCommonData(causeResp.data.data) : [];
    causeResp.data ? setPagesCount(causeResp.data.data.length) : [];
    causeResp.data ? setRenderList(causeResp.data.data.slice(0, 50)) : [];
  };
  useEffect(() => {
    fetchCauses();
  }, [clearSearch]);
  const fetchDataByOrg = async () => {
    console.log('fetch data by org');
    let causeAPI;
    let dataObj = {
      limit: pageObj.limit ? pageObj.limit : null,
      offset: pageObj.offset ? pageObj.offset : null,
      organizationId: orgdata,
    };
    if (!pageObj.limit) setPageObj(dataObj);
    if (user.userType === 'A') causeAPI = `${app.URL}/cause/viewdetailsByOrg`;
    const causeResp = await axios.post(causeAPI, dataObj, { headers: { auth: token } });
    console.log(causeResp)
    // let convertedObj;
    // eventResp.data ? (convertedObj = dateConverter(eventResp.data.data.data, 'startDate')) : ' ';
    causeResp&&causeResp.data ? setCause(causeResp.data.data) : [];
    causeResp&&causeResp.data ? setCommonData(causeResp.data.data) : [];
    causeResp&&causeResp.data ? setPagesCount(causeResp.data.data.length) : [];
    causeResp&&causeResp.data ? setRenderList(causeResp.data.data.slice(0, 50)) : [];
  };
  useEffect(() => {
    if (orgdata) fetchDataByOrg();
  }, [orgdata]);

let isOrgPortal=user.userType==="O"&&user.organizationId?true:false;
console.log("isOrgPortal",isOrgPortal);
  const onSearch = async (value) => {
    console.log(value);
    if (orgdata && !value) {
      fetchDataByOrg();
    }else if (isOrgPortal){
      try {
        const result = await axios.get(`${app.URL}/cause/search?organizationId=${user.organizationId}&searchTxt=${value}`, { headers: { auth: token } });
        console.log(result.data.data);
        result.data ? setCommonData(result.data.data) : [];
        result.data ? setRenderList(result.data.data.slice(0, 50)) : [];
        result.data ? setPagesCount(result.data.data.length) : 0;
      } catch (e) {
        console.log('Error');
        console.log(e);
        if (e.message) setErr(e.response.data.message);
        setTableShow(false);
      }
    }   
    else if (orgdata && value) {
      try {
        const result = await axios.get(`${app.URL}/cause/search?organizationId=${orgdata}&searchTxt=${value}`, { headers: { auth: token } });
        console.log(result.data.data);
        result.data ? setCommonData(result.data.data) : [];
        result.data ? setRenderList(result.data.data.slice(0, 50)) : [];
        result.data ? setPagesCount(result.data.data.length) : 0;
      } catch (e) {
        console.log('Error');
        console.log(e);
        if (e.message) setErr(e.response.data.message);
        setTableShow(false);
      }
    } else if (!orgdata && value) {
      try {
        const result = await axios.get(`${app.URL}/cause/search?searchTxt=${value}`, { headers: { auth: token } });
        console.log(result.data.data);
        result.data ? setCommonData(result.data.data) : [];
        result.data ? setRenderList(result.data.data.slice(0, 50)) : [];
        result.data ? setPagesCount(result.data.data.length) : 0;
      } catch (e) {
        console.log('Error');
        console.log(e);
        if (e.message) setErr(e.response.data.message);
        setTableShow(false);
      }
    } else {
      return;
    }
  };
  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(cause.slice(0, 50));
      setCommonData(cause);
      setCurrent(1);
      setPagesCount(cause.length);
    }
  };
  console.log(cause);
  const addCause = (e) => {
    console.log(e);
    if (user.userType === 'A') navigate('/cause/add', { replace: true });
    else if (user.userType === 'O') navigate('/causes/add', { replace: true });
  };
  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  const selectOrgId = (e) => {
    console.log('Select org Id');
    setOrgData(e);
    fetchDataByOrg();
  };
  const handleClearClick = () => {
    console.log('Clear search called');
    form.resetFields();
    setOrgData();
    fetchCauses();
    // console.log(document.getElementById('search').value);
    // document.getElementById('search').value = null;
    // document.getElementById('search').innerHTML = null;
    setClearSearch(true);
  };
  const editCause = (e) => {
    localStorage.setItem('causeId', JSON.stringify(e.causeId));
    if (user.userType === 'A') navigate('/cause/edit', { replace: true });
    else if (user.userType === 'O') navigate('/causes/edit', { replace: true });
  };
  const onChange = async (page, pageSize) => {
    console.log(page, pageSize);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    console.log(reqObj);
    setPageObj(reqObj);
    setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
  };
  console.log(renderList);
  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
      <div className='row'>
        <div className='col-lg-8 col-md-8 col-sm-12 '>
          <div class='mt-4 fs-3 fw-bold'> {t('Causes')} </div>
        </div>
      </div>
      <div className='row'>
        {user.userType === 'A' ? (
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div className='row text-left mt-4 mt-2'>
              <div className='col-lg-3 eventselect'>
                <Form.Item
                  form={form}
                  colon={false}
                  name='organizationId'
                  rules={[
                    {
                      required: false,
                      message: 'Select Organization',
                    },
                  ]}
                >
                  <Select
                    className='custom-select-dropdown'
                    listHeight={250}
                    listItemHeight={500}
                    onChange={selectOrgId}
                    style={{
                      display: 'inline-block ',
                    }}
                    placeholder='Select Organization'
                  >
                    {orgObj.map((orgs) => {
                      return (
                        <Option className='select-option' key={orgs.organizationId} value={orgs.organizationId}>
                          {orgs.organizationName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </div>
              <div className='col-lg-2'>
                <button class='btn btn-primary button' onKeyDown={() => {}} onClick={handleClearClick}>
                  Clear
                </button>
              </div>
              <div className='col-lg-3'>
                <Form.Item>
                  <Search
                    className='search'
                    placeholder='Search by Cause/ Category/ Org'
                    // onKeyDown={() => {}}
                    onSearch={onSearch}
                    onChange={handleSearchChange}
                    style={{
                      width: 300,
                    }}
                  />
                </Form.Item>
              </div>
              <div className='col-lg-3 offset-lg-1 text-center col-md-4 col-sm-12'>
                <button class='btn btn-primary button' onClick={addCause}>
                  Add Cause
                </button>
              </div>
            </div>
          </Form>
        ) : (
          ' '
        )}
        {user.userType === 'O' ? (
          <Form
            name='basic'
            form={form}
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
          >
            <div className='row mt-4'>
              <div className='col-lg-7 text-right'>
                <Form.Item>
                  <Search
                    className='search'
                    placeholder='Search by Cause/ Category/ Org'
                    onSearch={onSearch}
                    onChange={handleSearchChange}
                    style={{
                      width: 300,
                    }}
                  />
                </Form.Item>
              </div>
              <div className='col-lg-4 text-right col-md-4 col-sm-12'>
                <button class='btn btn-primary button' onClick={addCause}>
                  Add Cause
                </button>
              </div>
            </div>
          </Form>
        ) : (
          ' '
        )}
      </div>

      <div className='col-lg-11 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                {/* <th>{t("ID")}</th> */}
                {user.userType === 'A' ? <th>{t('Organization')}</th> : ' '}
                <th>{t('Cause')}</th>
                <th>{t('Cause Category')}</th>
                {/* <th>{t('Display Position')}</th> */}
                <th>{t('Recurring')}</th>
                <th>{t('Fee (%)')}</th>
                <th>{t('Fee Status')}</th>
                <th>{t('Status')}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr
                      className='row-hover'
                      onClick={() => {
                        editCause(output);
                      }}
                    >
                      {user.userType === 'A' ? <td style={{ width: '300px' }}>{output.organizationName}</td> : ' '}
                      <td style={{ width: '250px' }}>{output.cause ? output.cause : 'null'}</td>

                      <td style={{ width: '250px' }}>{output.causeCategory ? output.causeCategory : 'null'}</td>
                      {/* <td className='pl-4' style={{ width: '250px' }}>
                        {output.displayPosition ? output.displayPosition : 'null'}
                      </td> */}
                      <td style={{ width: '160px', paddingLeft: '40px' }} className='ml-20'>
                      {output.recurring === 'Active' ? <CheckCircleFilled style={{ fontSize: '25px', color: '#054155' }} /> : <p style={{ paddingLeft: '10px', color: 'black' }}>-</p>}
                      </td>
                      <td className='pl-4' style={{ width: '250px' }}>
                        {output.serviceFee ? output.serviceFee : 0}
                      </td>
                      <td style={{ width: '160px', paddingLeft: '40px' }} className='ml-20'>
                        {output.feeStatus ? <CheckCircleFilled style={{ fontSize: '25px', color: '#054155' }} /> : <p style={{paddingLeft:'10px',color:'black'}}>-</p>}
                      </td>
                      <td style={{ width: '160px' }}>{output.status ? output.status : 'N/A'}</td>
                      <td style={{ width: '30px' }}>
                        <EditTwoTone
                          displayName='edit'
                          twoToneColor='blue'
                          style={{ fontSize: '20px' }}
                          onClick={() => {
                            editCause(output);
                          }}
                        />
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>

          {renderList && renderList.length == 0 ? <NoRecordFound /> : ' '}
        </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} current={current} defaultCurrent={current} pageSize={50} total={pagesCount} />
    </div>
  );
};

export default Cause;
